export interface PreviewOccurrenceInput {
  startUtc: Date | string;
  endUtc: Date | string;
  isHidden?: boolean | null;
}

export interface PreviewRecurrenceInput {
  startUtc: Date | string;
  endUtc: Date | string;
}

export interface PreviewEventDates {
  startUtc: Date;
  endUtc: Date;
}

const toSortedDates = (entries: PreviewRecurrenceInput[]): PreviewEventDates[] =>
  entries
    .map((entry) => ({ startUtc: new Date(entry.startUtc), endUtc: new Date(entry.endUtc) }))
    .filter((entry) => !isNaN(entry.startUtc.getTime()) && !isNaN(entry.endUtc.getTime()))
    .sort((first, second) => first.startUtc.getTime() - second.startUtc.getTime());

export const getPreviewEventDates = ({
  occurrences,
  recurrences,
}: {
  occurrences?: PreviewOccurrenceInput[] | null;
  recurrences?: PreviewRecurrenceInput[] | null;
}): PreviewEventDates | null => {
  const visibleOccurrences = toSortedDates((occurrences ?? []).filter((occurrence) => !occurrence.isHidden));

  const now = Date.now();
  const upcoming = visibleOccurrences.find((occurrence) => occurrence.endUtc.getTime() >= now);
  if (upcoming) {
    return upcoming;
  }

  if (visibleOccurrences.length > 0) {
    return visibleOccurrences[visibleOccurrences.length - 1];
  }

  return toSortedDates(recurrences ?? [])[0] ?? null;
};
